import React from "react";
import { useTheme } from "../../../core/contexts/ThemeContext";
import UserDetail from "./Common/UserDetail";

function Header(props) {
  const { rucmonkeyTheme } = useTheme();

  return (
    // <nav className="navbar navbar-expand-lg fixed-top navbar-transparent ">
    <nav
      className="navbar navbar-expand-lg fixed-top navbar-transparent navbar-height"
      style={rucmonkeyTheme ?? null}
    >
      <div className="container-fluid">
        <div className="navbar-wrapper">
          <div
            className="navbar-toggle nav-custom-bolck"
            style={{ display: "block" }}
          >
            <button
              type="button nav-custom-bolck"
              style={{ display: "block" }}
              className="navbar-toggler"
            >
              <span className="navbar-toggler-bar bar1"></span>
              <span className="navbar-toggler-bar bar2"></span>
              <span className="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <div className=" no-border d-none d-sm-block"></div>

          <ul className="navbar-nav-map header-title">{props.title}</ul>
        </div>

        <button
          //ref={menuBarRef}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigation"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="nc-icon nc-minimal-down"></i>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navigation"
        >
          <div className="d-xs-block d-sm-none d-md-none d-lg-none"></div>
          <UserDetail />
        </div>
      </div>
    </nav>
  );
}

export default Header;
